import { useState } from 'react';

interface LocationNamingCardProps {
  coordinates: [number, number];
  onSubmit: (name: string) => void;
  onCancel: () => void;
}

export function LocationNamingCard({ coordinates, onSubmit, onCancel }: LocationNamingCardProps) {
  const [name, setName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      onSubmit(name.trim());
    }
  };

  return (
    <div className="absolute inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-20 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-lg w-full max-w-sm">
        {/* Header */}
        <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
          <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100">
            Name this location
          </h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            {coordinates[1].toFixed(4)}, {coordinates[0].toFixed(4)}
          </p>
        </div>

        {/* Content */}
        <div className="p-4">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
                Location name
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g. My favorite spot"
                className="w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg text-sm text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-pink-500/20 focus:border-pink-300 dark:focus:border-pink-500 transition-colors"
                autoFocus
              />
            </div>

            <div className="flex gap-2">
              <button
                type="button"
                onClick={onCancel}
                className="px-3 py-2 text-sm font-medium rounded-lg border transition-colors bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-600"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={!name.trim()}
                className={`
                  px-3 py-2 text-sm font-medium rounded-lg transition-colors
                  ${
                    !name.trim()
                      ? 'bg-gray-200 dark:bg-gray-600 text-gray-400 dark:text-gray-500 cursor-not-allowed'
                      : 'text-white bg-[#E34290] hover:bg-[#C93B82] focus:bg-[#C93B82]'
                  }
                `}
              >
                Add to Favorites
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
